// TODO: Allow light and dark mode use

export const DropDownArrowSvg = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      className="fill-zinc-500 flex-none"
    >
      <path d="M1.76619 1.5L10.2338 1.5C11.0111 1.5 11.4912 2.34797 11.0913 3.0145L6.85749 10.0708C6.46909 10.7182 5.53091 10.7182 5.14251 10.0708L0.908697 3.0145C0.508782 2.34797 0.988895 1.5 1.76619 1.5Z" />
    </svg>
  )
}
